import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from "../store";

const ifNotAuthenticated = (to, from, next) => {
   if (!store.getters.isAuthenticated) {
     next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { layout: "ConnexionLayout" },
    component: () => import('../views/LoginView.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/',
    name: 'HomeView',
    meta: { menuActive: "home" },
    component: HomeView,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/metadata-analysis',
    name: 'MetadataAnalysis',
    meta: { menuActive: "analysis" },
    component: () => import('../views/MetadataAnalysisView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/flow-analysis',
    name: 'FlowAnalysis',
    meta: { menuActive: "flow" },
    component: () => import('../views/FlowAnalysisView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/development-quality',
    name: 'DevelopmentQuality',
    meta: { menuActive: "quality" },
    component: () => import('../views/DevelopmentQualityView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/amc',
    name: 'AMC',
    meta: { menuActive: "amc" },
    component: () => import('../views/AMCView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/migration',
    name: 'Migration',
    meta: { menuActive: "migration" },
    component: () => import('../views/MigrationView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/administration',
    name: 'Administration',
    meta: { menuActive: "administration" },
    component: () => import('../views/AdministrationView.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/administrationOnDemand',
    name: 'AdministrationOND',
    meta: { menuActive: "administrationOND" },
    component: () => import('../views/AdministrationOND'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/DataCatalog',
    name: 'DataCatalog',
    meta: { menuActive: "DataCatalog" },
    component: () => import('../views/DataCatalog.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/ChatBot',
    name: 'ChatBot',
    meta: { menuActive: "ChatBot" },
    component: () => import('../views/ChatBot.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/notifications',
    name: 'Alerts',
    meta: { menuActive: "alerts" },
    component: () => import('../views/AlertsView.vue'),
    beforeEnter: ifAuthenticated
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
